<template>
  <page>
    <v-card>
      <v-card-title>
        <div>
          <div class="headline">Class Listing</div>
        </div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.vesCls }}</td>
          <td class="text-xs-left">{{ props.item.vesClsDesc }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" review @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
      <v-btn color="primary" dark class="mb-2" @click="doNew">New Class<v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-card>
    <v-dialog v-model="classDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ labels.valueFormTitle }}</span>
        </v-card-title>
        <v-card-text>
          <message :messages="messages"></message>
          <form>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs6 v-if="newClass">
                  <v-text-field v-model="classForm.vesCls" :label="labels.vesCls" :error-messages="errors.collect('vesCls')" data-vv-name="vesCls" :data-vv-as="labels.vesCls" v-validate="'required|param|max:8'"></v-text-field>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-subheader class="queryLabel">{{labels.vesCls}}</v-subheader>
                  <div class="subheading">{{classForm.vesCls}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-model="classForm.vesClsDesc" :label="labels.vesClsDesc" :error-messages="errors.collect('vesClsDesc')" v-validate="'required|entry|max:80'" data-vv-name="vesClsDesc" :data-vv-as="labels.vesClsDesc"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
          <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Vessel Class? ({{deleteVesCls}})
    </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {
      headers: [
        { text: 'Vessel Class', value: 'vesCls' },
        { text: 'Vessel Class Description', value: 'vesClsDesc' },
        TableConst.tableActionHeader
      ],
      labels: {
        valueFormTitle: 'Vessel Class Details',
        vesCls: 'Vessel Class*',
        vesClsDesc: 'Vessel Class Description*'
      },
      classForm: {
        vesCls: null,
        vesClsDesc: null
      },
      filters: {
        vesCls: null,
        vesClsDesc: null
      },
      classDialog: null,
      newClass: null,
      sumbitting: undefined,
      promptRemove: false,
      selectedVesCls: undefined,
      deleteVesCls: ''
    }
  },
  computed: {
    cls() {
      return this.$store.state.vessel.menu
    }
  },
  methods: {
    async init() {
      this.loading = true
      const apiURI = this.cls.getVslClasses
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((vesCls) => {
              const convertClass = {
                vesCls: vesCls.vesCls,
                vesClsDesc: vesCls.vesClsDesc
              }
              this.items.push(convertClass)
            })
            this.loading = false
          }
        } catch (error) {
          this.loading = false
        }
      } else {
        this.loading = false
      }
    },
    async doInit() {
      // await this.$store.dispatch('vesselManagementInit')
      this.init()
    },
    async doReview(data) {
      this.classDialog = true
      this.newClass = false
      const apiURI = this.cls.getVslClass
      const expand = {
        vesCls: data.item.vesCls
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.classForm.vesCls = data.vesCls.vesCls
          this.classForm.vesClsDesc = data.vesCls.vesClsDesc
        }
        this.classDialog = true
      }
    },
    doNew() {
      this.resetValidator()
      this.resetMessages()
      this.newClass = true
      this.classDialog = true
    },
    doClose() {
      this.newClass = false
      this.classDialog = false
      this.classForm.vesCls = null
      this.classForm.vesClsDesc = null
      this.resetValidator()
      this.resetMessages()
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newClass) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.cls.createVslClass
      if (apiURI) {
        this.sumbitting = true
        try {
          const result = await this.$http.post(apiURI, this.classForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.cls.updateVslClass
      if (apiURI) {
        this.sumbitting = true
        try {
          const result = await this.$http.put(apiURI, this.classForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedVesCls = data
        this.deleteVesCls = data.vesCls + ' - ' + data.vesClsDesc
      }
    },
    async doRemove() {
      const apiURI = this.cls.deleteVslClass
      if (apiURI) {
        const expand = this.selectedVesCls
        this.$http.post(apiURI, expand).then(result => {
          const data = result.data
          this.notify(data)
          this.init()
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        })
      }
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>
</style>
